import React from "react";
import "./TextContent.scss";

const TextContent = ({ data, userAgent }) => {
  console.log("TextContent", data);
  return (
    <div className="text-content">
      {data?.main_title && <h1>{data?.main_title}</h1>}
      {data?.paragraph && <p>{data?.paragraph}</p>}
    </div>
  );
};

export default TextContent;
